
import moment from 'moment-timezone';
import { Component, Vue, Watch, Prop, VModel } from 'vue-property-decorator';

// Timezone pro zobrazování - vždy Praha bez ohledu na TZ prohlížeče
const DISPLAY_TIMEZONE = 'Europe/Prague';

@Component
export default class DatePicker extends Vue {
    menu = false;
    text = '';

    date: string | null = null;
    modal = false;
    menu2 = false;
    isUpdatingFromInnerValue = false;
    isUpdatingFromDate = false;

    @VModel() innerValue!: string;
    @Prop() value!: [string];
    @Prop() min!: [string];
    @Prop() max!: [string];
    @Prop() label!: [string];
    @Prop() placeholder!: [string];
    @Prop({ default: false }) readonly!: boolean;
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) hideDetails!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) dayButtons!: boolean;
    @Prop({ default: false }) clearable!: boolean;
    @Prop({ default: 0 }) maxWidth!: number;
    @Prop({ default: '' }) labelClass!: string;

    get rules(): any[] {
        let rules: any[] = [];
        if (this.required) {
            rules.push((v: any) => !!v || this.$i18n.t('common.thisFileIsRequired'));
            if (this.min && moment(this.min).isValid()) {
                rules.push(
                    (v: any) =>
                        (moment(v, 'DD.MM.YYYY').isValid() && moment(v, 'DD.MM.YYYY').isSameOrAfter(moment(this.min))) ||
                        'Minimální datum ' + moment(this.min).format('DD.MM.YYYY')
                );
            }
            if (this.max && moment(this.max).isValid()) {
                rules.push(
                    (v: any) =>
                        (moment(v, 'DD.MM.YYYY').isValid() && moment(v, 'DD.MM.YYYY').isSameOrBefore(moment(this.max))) ||
                        'Maximální datum ' + moment(this.max).format('DD.MM.YYYY')
                );
            }
        }
        return rules;
    }

    get isMobile(): boolean {
        return this.$vuetify.breakpoint.width < 576;
    }

    mounted() {
        if (this.value) {
            const dateInPrague = moment.tz(this.value, DISPLAY_TIMEZONE);
            this.date = dateInPrague.format('YYYY-MM-DD');
            this.text = dateInPrague.format('DD.MM.YYYY');
        }
    }

    @Watch('innerValue')
    innerValueChanged(v: string, p: string) {
        if (v == p) return;
        if (this.isUpdatingFromDate) {
            this.isUpdatingFromDate = false;
            return;
        }

        this.isUpdatingFromInnerValue = true;
        if (v) {
            const dateInPrague = moment.tz(v, DISPLAY_TIMEZONE);
            this.date = dateInPrague.format('YYYY-MM-DD');
            this.text = dateInPrague.format('DD.MM.YYYY');
        } else {
            if (this.date) {
                this.date = null;
            }
            if (this.text) {
                this.text = '';
            }
        }
        this.isUpdatingFromInnerValue = false;
    }

    @Watch('date')
    dateChanged(v: string, p: string) {
        if (v == p) return;
        if (this.isUpdatingFromInnerValue) {
            return;
        }

        this.isUpdatingFromDate = true;
        if (v == null) {
            this.$emit('input', null);
            this.text = '';
        } else {
            // Vytvoříme datum v Prague timezone
            const dateInPrague = moment.tz(v, DISPLAY_TIMEZONE);
            this.$emit('input', dateInPrague.format('YYYY-MM-DDTHH:mm:ss'));
            this.text = dateInPrague.format('DD.MM.YYYY');
        }
        this.isUpdatingFromDate = false;
    }

    @Watch('text')
    textChanged(v: string, p: string) {
        if (this.isUpdatingFromInnerValue || this.isUpdatingFromDate) {
            return;
        }

        const dateRegEx = /^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{4}$/;
        if (moment(v, 'DD.MM.YYYY').isValid() && dateRegEx.test(v)) {
            this.date = moment.tz(v, 'DD.MM.YYYY', DISPLAY_TIMEZONE).format('YYYY-MM-DD');
        } else if (!v && this.date) {
            this.text = '';
            this.date = null;
        }
    }

    addDaysFromToday(days: number) {
        this.date = moment.tz(DISPLAY_TIMEZONE).add(days, 'days').format('YYYY-MM-DD');
    }
}
